export default "__VITE_ASSET__DTGAQv_$__"